module.exports = __webpack_public_path__ + "static/media/users-solid.efdc0f9e.svg";